import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import TextInput from "../../inputs/TextInput";
import { TextField } from "@mui/material";

const RffTextField = React.memo(function RffTextField({
  name,
  label,
  required,
  placeholder = "Enter value",
  suppressGrid,
  inlineLabel = false,
  size,
  helperText,
  disabled,
  onBlur, // This is the onBlur passed from enhanceFieldWithBlurHandler
  testing,
  sx,
}) {
  // Only re-create this validate function when "required" changes
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  return (
    <RffInputWrapper
      label={inlineLabel ? null : label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      testing={testing}
    >
      <Field
        name={name}
        validate={validate}
        // 1) Only subscribe to the needed bits of Field state
        subscription={{ value: true, error: true, touched: true }}
        render={({ input, meta }) => {
          if (inlineLabel) {
            return (
              <TextField
                {...input}
                sx={sx}
                label={label}
                // Replace the onBlur with our wrapped handler
                onBlur={onBlur}
                // onBlur={handleBlur}
                disabled={disabled}
                placeholder={placeholder}
                error={meta.touched && !!meta.error}
                helperText={(meta.touched && meta.error) || helperText}
              />
            );
          }

          return (
            <TextInput
              {...input}
              sx={sx}
              // Replace the onBlur with our wrapped handler
              onBlur={onBlur}
              // onBlur={handleBlur}
              disabled={disabled}
              placeholder={placeholder}
              error={meta.touched && !!meta.error}
              helperText={(meta.touched && meta.error) || helperText}
            />
          );
        }}
      />
    </RffInputWrapper>
  );
});

export default RffTextField;
